import { SkeletonLoading } from '@app/shared';
import { ElementIdTab, getProductTabs, productActions, TabTitle } from '@entities/Product';
import { quantityLimitation, scrollToElement } from '@shared/helpers';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { AvailableStringByCartProduct, AvailableStringProductRow, AvailableType } from '@entities/Delivery/module/types/deliveryTypes';
import { getIsLoaded, getListOrderFromStock, getOverall } from '@entities/Shop';
import { DefaultProps } from '@app/Types/global.interfaces';
import { useWindowSizing } from '@hooks/useSizeWindow';
import { getAnchor } from '../../module/helpers/getAnchor';
import { showAvailabilityLater } from '../../module/helpers/showAvailabilityLater';
import classNames from 'classnames';

import styles from './RowAvailability.module.scss';

export const CartProductRowAvailability = ({ className }: DefaultProps) => {
  const isMobile = useWindowSizing(990);
  const tabList = useAppSelector(getProductTabs);
  const dispatch = useAppDispatch();
  const data = useAppSelector(getOverall);
  const order = useAppSelector(getListOrderFromStock);
  const isLoaded = useAppSelector(getIsLoaded);

  const handlerScrollToBlock = blockId => {
    dispatch(productActions.setActiveTab(tabList.findIndex(x => x.title === TabTitle.Availability)));
    setTimeout(() => {
      scrollToElement(document.getElementById(blockId), { scrollIntoView: isMobile });
    }, 300);
  };

  if (!data && !isLoaded) {
    return <CartProductRowAvailability.Skeleton className={className} />;
  } else if (!data) {
    return null;
  } else {
    const { availabilityLater, availabilityNow } = data;
    return (
      <div className={classNames(styles.WrapperRowAvailability, className)}>
        {!!availabilityNow?.quantity && (
          <div onClick={() => handlerScrollToBlock(ElementIdTab.TabAvailabilityFast)} className={styles.inStock}>
            {`${quantityLimitation(availabilityNow.quantity)} шт. ${AvailableStringProductRow[availabilityNow.type]}`}
          </div>
        )}
        {showAvailabilityLater(availabilityLater?.quantity, availabilityNow?.quantity) && (
          <div onClick={() => handlerScrollToBlock(getAnchor(availabilityLater, order))} className={styles.onOrder}>
            {`${quantityLimitation(availabilityLater.quantity)} шт. ${AvailableStringProductRow[availabilityLater.type]}`}
          </div>
        )}
        {!availabilityNow?.quantity && !availabilityLater?.quantity && (
          <div className={styles.onOrder}>{AvailableStringByCartProduct[AvailableType.NoInfo]}</div>
        )}
      </div>
    );
  }
};

CartProductRowAvailability.Skeleton = function Skeleton({ className }: DefaultProps) {
  return (
    <div className={classNames(styles.WrapperRowAvailability, className)}>
      <SkeletonLoading width={'100%'} height={'21px'} />
    </div>
  );
};
